///<reference path="smart-mover.models.ts"/>

module Meevo.Components.Controls.SmartMover {

    export interface ILimitationsBase {
        collection: ICollectionBase<any>;
        limitationReached(lastChangedModelId: ModelValueType): boolean;
    }

    export abstract class LimitationsBase implements ILimitationsBase {

        protected oldValue: ICollectionBase<any>;

        constructor(public collection: ICollectionBase<any>, $scope: ng.IScope, limitationReachedCallback: (...args: any[]) => void) {

            $scope.$watch(() => collection.selectedModels.length, (newValue, oldValue) => {
                if (typeof newValue !== 'number' || newValue === oldValue && newValue === collection.models.length) return;

                const lastChangedModel: ModelValueType = _.difference(this.collection.value, (this.oldValue || {} as ICollectionBase<any>).value || [])[0];

                if (this.limitationReached(lastChangedModel)) {
                    limitationReachedCallback(lastChangedModel);

                    this.oldValue = angular.copy(this.collection);
                }

                this.oldValue = angular.copy(this.collection);
            });
        }

        abstract limitationReached(lastChangedModelId: ModelValueType): boolean;
    }
}
